import { render, staticRenderFns } from "./asset_alert_history.vue?vue&type=template&id=14054cf0&"
import script from "./asset_alert_history.vue?vue&type=script&lang=js&"
export * from "./asset_alert_history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports